import React from 'react';
import { Check } from 'lucide-react';
import { whoIsThisFor, marketingImages } from '../../data/mock';

const WhoIsThisFor = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="flex justify-center">
              <img 
                src={marketingImages.platforms} 
                alt="Building Financial Stability"
                className="w-full max-w-md rounded-2xl shadow-xl"
              />
            </div>

            {/* Content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Who This Guide Is For
              </h2>
              <p className="text-gray-600 text-lg mb-8">
                This practical strategy guide is designed for anyone ready to take control of their financial future.
              </p>

              <div className="space-y-4">
                {whoIsThisFor.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-4">
                    <div className="w-6 h-6 rounded-full bg-teal-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <span className="text-gray-700 text-lg">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIsThisFor;
